// Pure logic of the optimization screen, shared with the tests.

/** Months whose peak went over a contracted power, and the effect of that power a year (PLN). */
export interface PowerSimulation {
  over: number[];
  saving: number;
  penalties: number;
  net: number;
}

/**
 * The effect of contracting `proposedKw` instead of `currentKw`: the fixed charge saved a year, minus charges for
 * exceeding it in the months whose peak was higher: `penaltyPerKw` for each kW over, per month — the contract's rate,
 * or by default ten times the fixed rate (a usual operator rule).
 */
export function simulatePower(
  peaks: readonly number[],
  currentKw: number,
  proposedKw: number,
  ratePerKwMonth: number,
  penaltyPerKw = ratePerKwMonth * 10,
): PowerSimulation {
  const over = peaks
    .map((p, i) => (p > proposedKw ? i : -1))
    .filter((i) => i >= 0);
  const saving = (currentKw - proposedKw) * ratePerKwMonth * 12;
  const penalties = over.reduce(
    (s, i) => s + (peaks[i]! - proposedKw) * penaltyPerKw,
    0,
  );
  return { over, saving, penalties, net: saving - penalties };
}
